import { AuthenticatedTemplate } from '@azure/msal-react';
import { Link } from 'react-router-dom';
import { Login } from '../../../Login';
import Hero from '../../common/layout/Hero';
import HeroBody from '../../common/layout/HeroBody';
import Container from '../../common/layout/Container';
import { ThorProvider } from '../context/ThorContext';
import ResurrectorManager from '../components/ResurrectorManager';
import ThorToast from '../components/ThorToast';
import '../css/thor.css';

const ThorResurrectorContent = () => (
    <>
        <Container>
            <Hero>
                <HeroBody>
                    <p className="title is-1">Thor</p>
                    <p className="subtitle is-5 has-text-grey">Experiment management — design, review, run, and analyze A/B tests.</p>
                </HeroBody>
            </Hero>

            <div className="tabs mb-4">
                <ul>
                    <li><Link to="/thor/experiments">Experiments</Link></li>
                    <li><Link to="/thor/audiences">Audience Library</Link></li>
                    <li><Link to="/thor/exclusion-groups">Exclusion Groups</Link></li>
                    <li className="is-active"><Link to="/thor/resurrector">Resurrector</Link></li>
                </ul>
            </div>

            <div className="box">
                <p className="subtitle is-5 mb-1">Resurrector</p>
                <p className="has-text-grey is-size-7 mb-4">
                    Restore archived experiments back to active state. Search by experiment key to find the one you need.
                </p>
                <ResurrectorManager />
            </div>
        </Container>
        <ThorToast />
    </>
);

export const ThorResurrectorPage = () => (
    <>
        <Login />
        <AuthenticatedTemplate>
            <ThorProvider>
                <ThorResurrectorContent />
            </ThorProvider>
        </AuthenticatedTemplate>
    </>
);

export default ThorResurrectorPage;
